// Strip HTML tags, CSS blocks, and collapse whitespace. Some legacy
// notifications and activity rows store full email HTML in their message
// body, which leaks markup like "@media only screen ..." into public-facing
// notification and activity feeds. Use this everywhere a raw description or
// message is rendered to end users.
export const sanitizeActivityText = (raw: string | null | undefined): string => {
  if (!raw) return '';
  const original = String(raw);
  let s = original;
  // Remove MIME transport metadata and boundaries before rendering. These
  // are email protocol details, never useful notification copy.
  s = s.replace(/^\s*(content-type|content-transfer-encoding|content-disposition|mime-version|charset|boundary)\s*:[^\r\n]*(?:\r?\n[ \t]+[^\r\n]*)?/gim, ' ');
  s = s.replace(/^\s*--[^\r\n]+(?:--)?\s*$/gm, ' ');
  s = s.replace(/\b(content-type|content-transfer-encoding|content-disposition|mime-version|charset|boundary)\s*:\s*[^\r\n;]*(?:;\s*[^\r\n]*)?/gi, ' ');
  s = s.replace(/<style[\s\S]*?<\/style>/gi, ' ');
  s = s.replace(/<script[\s\S]*?<\/script>/gi, ' ');
  s = s.replace(/<\/?[^>]+>/g, ' ');
  // Iteratively strip innermost CSS rule blocks `{ ... }` until none remain.
  // Handles nested @media { .x { ... } } correctly.
  let prev: string;
  let guard = 0;
  do {
    prev = s;
    s = s.replace(/\{[^{}]*\}/g, ' ');
    guard++;
  } while (s !== prev && guard < 20);
  s = s.replace(/@[a-z-]+[^;{}\n]*/gi, ' ');
  s = s.replace(/[{}]/g, ' ');
  s = s
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");
  s = s.replace(/\s+/g, ' ').trim();
  if (
    /(^|\s)\.[a-z][\w-]+/i.test(s) ||
    /\b(padding|margin|width|height|color|font|border|background|display|line-height|max-width|min-width)\s*:/i.test(s) ||
    /\d+\s*px\b/.test(s) ||
    /\bmultipart\/(alternative|mixed|related)\b/i.test(s) ||
    /\bcontent-transfer-encoding\b/i.test(s)
  ) {
    // Salvage a clean human-readable prefix before the first ":" if the rest
    // is just embedded HTML/CSS from an email body.
    const colonIdx = original.indexOf(':');
    if (colonIdx > 0 && colonIdx < 200) {
      const prefix = original.slice(0, colonIdx).replace(/<[^>]*>/g, '').trim();
      if (
        prefix &&
        !/[{}]/.test(prefix) &&
        !/@[a-z-]+/i.test(prefix) &&
        !/\d+\s*px\b/.test(prefix)
      ) {
        return prefix.length > 180 ? prefix.slice(0, 177) + '…' : prefix;
      }
    }
    return '';
  }
  if (s.length > 180) s = s.slice(0, 177) + '…';
  return s;
};